import {useInfiniteQuery} from '@tanstack/react-query';
import {fetchArticles} from '../services/api';
import {Article} from '../types/article';

export const useArticles = () => {
  return useInfiniteQuery({
    queryKey: ['articles'],
    queryFn: ({pageParam = 1}) => fetchArticles(pageParam),
    getNextPageParam: (lastPage) => {
      const {current_page, last_page} = lastPage.meta;
      return current_page < last_page ? current_page + 1 : undefined;
    },
    initialPageParam: 1,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: true,
  });
};
